<template>
  <div class="news-feed-page container homebase-container pt-5 pb-5">
    <div><back-to-home-button /></div>
    <news-feed
      :title="formattedTitle"
      :posts="posts"
      :topics="topics"
      :is-loading="isLoading"
      :is-errored="isErrored"
      :is-full-page="true"
      :enable-edit-interests="enableByInterests"
      :enable-load-more="true"
      :show-load-more="showLoadMore"
      :is-more-loading="isMoreLoading"
      :is-filtered-search-loading="isFilteredSearchLoading"
      @onLoadMore="handleLoadMoreClicked"
      @onFilteredSearch="handleFilteredSearchClicked"
      @onResetFilters="resetNewsFeed"
      @interestsSaved="resetNewsFeed"
    />
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";

import NewsFeed from "./newsByInterests/NewsFeed";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import BackToHomeButton from "@/components/homebase/buttons/BackToHomeButton";

export default {
  name: "news-feed-page",
  mixins: [HomebaseMixpanelMixin],
  components: {
    NewsFeed,
    BackToHomeButton
  },
  data() {
    return {
      CONSTANTS,
      isLoading: false,
      isMoreLoading: false,
      isFilteredSearchLoading: false,
      isErrored: false,
      title: null,
      enableByInterests: false,
      posts: [],
      topics: null,
      filters: null,
      filtersEnabled: false,

      // pagination
      currentPage: 1,
      pageCount: 1,
      pageSize: 10,
      showLoadMore: false,
    };
  },
  computed: {
    formattedTitle() {
      return `<h1>${this.title}</h1>`
    }
  },
  created() {
    this.initializeNewsFeed();
  },
  methods: {
    initializeNewsFeed() {
      this.enableByInterests = !!this.$route.meta.enableByInterests;
      this.title = this.enableByInterests
        ? `News based on your interests`
        : `News`;
      this.trackAutodeskOnePageHit(this.title);
      this.resetNewsFeed();
    },

    resetNewsFeed() {
      this.posts = [];
      this.topics = null;
      this.pageCount = 1;
      this.currentPage = 1;
      this.message = null;
      this.filters = null;
      this.filtersEnabled = false;
      this.enableByInterests ? this.getNewsByInterests() : this.getTopNews();
    },

    setIsLoading(value) {
      if (this.currentPage == 1) {
        if(this.filtersEnabled) {
          this.isFilteredSearchLoading = value;
        } else {
          this.isLoading = value;
        }
      } else {
        this.isMoreLoading = value;
      }
    },

    async getTopNews() {
      this.setIsLoading(true);
      try {
        let offset = this.getQueryOffset();
        let res = await api.getNewsPosts(offset, this.pageSize);
        let posts = res.data.data.news.news;
        this.posts = this.posts.concat(posts);

        // pagination
        let total = res.data.data.news.total;
        this.setPaginationConfig(total);
      } catch (e) {
        this.isErrored = true;
      } finally {
        this.setIsLoading(false);
      }
    },

    async getNewsByInterests() {
      this.setIsLoading(true);
      try {
        let offset = this.getQueryOffset();
        let newsRes = await api.getNewsByInterests(offset, this.pageSize);
        let news = newsRes.data.data.newsByInterest.news.news;
        this.posts = this.posts.concat(news);
        this.topics = newsRes.data.data.newsByInterest.topics;

        // pagination config
        let total = newsRes.data.data.newsByInterest.news.total;
        this.setPaginationConfig(total);
      } catch (e) {
        this.isErrored = true;
      } finally {
        this.setIsLoading(false);
      }
    },

    async getFilteredNews(filters) {
      this.setIsLoading(true);
      try {
        let offset = this.getQueryOffset();
        let res = await api.getFilteredNewsPosts(offset, this.pageSize, filters);
        this.posts = this.currentPage > 1 ? this.posts : [];
        
        if(res.data.data.news) {
          let posts = res.data.data.news.news;
          this.posts = this.posts.concat(posts);

          // pagination
          let total = res.data.data.news.total;
          this.setPaginationConfig(total);
          this.filters = filters;
        }
      } catch (e) {
        this.isErrored = true;
      } finally {
        this.setIsLoading(false);
      }
    },

    setPaginationConfig(total) {
      this.pageCount = Math.ceil(total / this.pageSize);
      this.setShowLoadMore(total);
    },

    getQueryOffset() {
      let offset = (this.currentPage - 1) * this.pageSize;
      return offset;
    },

    async handleLoadMoreClicked() {
      let event = `${this.title} page - load more clicked`;
      this.trackNewsFeedLoadMoreClicked(event);

      ++this.currentPage;
      if(this.filters) {
        await this.getFilteredNews(this.filters);
      }
      else {
        this.enableByInterests
        ? await this.getNewsByInterests()
        : await this.getTopNews();
      }
    },

    async handleFilteredSearchClicked(filters) {
      let event = `${this.title} page - news feed filtered search triggered`;
      this.trackNewsFeedFilteredSearch(event, filters);

      this.currentPage = 1;  
      this.filtersEnabled = true;
      await this.getFilteredNews(filters);
    },

    setShowLoadMore(total) {
      this.showLoadMore = this.currentPage * this.pageSize < total;
    },
  },
};
</script>

<style scoped src="../../../static/aone-theme.css"></style>
<style scoped>
.news-feed-page {
  min-height: 600px;
}
</style>
